import React from 'react'
import "../../stylings/message.css"
import chairmanPhoto from "../../assest/chairmanPhoto.jpg"
import principalPhoto from "../../assest/principalPhoto.jpg"
import { Link } from 'react-router-dom'

const Message = () => {
    return (
        <section className="message-section-wrapper">
            <div className="container">

                <div className="message-section-header">
                    <div className="section-tag">
                        <i className="fa-solid fa-quote-left"></i>
                        Leadership Messages
                    </div>
                    <h2>A Word From Our Leaders</h2>
                    <div className="divider"></div>
                </div>

                <div className="message-cards-grid">

                    {/* Chairperson */}
                    <div className="message-card">
                        <div className="message-card-header">
                            <img src={chairmanPhoto} alt="Chairperson" className="message-photo" />
                            <div className="message-card-header-info">
                                <div className="message-role">Chairperson</div>
                                <div className="message-name">Mrs. Vidya Jain</div>
                                <div className="message-exp">
                                    <i className="fa-solid fa-star"></i>
                                    35+ Years of Experience
                                </div>
                            </div>
                        </div>
                        <div className="message-card-body">
                            <p>
                                Welcome to Vidya Jain Convent School! We endeavor to cultivate greatness in instruction
                                and contribute to the continuous improvement of student learning and the school climate
                                by providing evidence-based literacy strategies and resources to all stakeholders.
                            </p>
                            <p>
                                We look forward to working with you and your child as we make a difference in the lives
                                of our children. Our focus is on implementing a strong, challenging academic foundation
                                while providing the highest quality education — creating a school where students feel
                                safe and empowered to learn.
                            </p>
                        </div>
                        <div className="message-card-footer">
                            <Link to="/chairman-message" className="message-read-more">
                                Read Full Message <i className="fa-solid fa-arrow-right"></i>
                            </Link>
                        </div>
                    </div>

                    {/* Principal */}
                    <div className="message-card">
                        <div className="message-card-header">
                            <img src={principalPhoto} alt="Principal" className="message-photo" />
                            <div className="message-card-header-info">
                                <div className="message-role">Principal</div>
                                <div className="message-name">Mr. Naresh Kumar Jain</div>
                                <div className="message-exp">
                                    <i className="fa-solid fa-star"></i>
                                    16+ Years of Experience
                                </div>
                            </div>
                        </div>
                        <div className="message-card-body">
                            <p>
                                We are proud of our school and invite you to explore our website to learn more.
                                We are a collaborative coalition of dedicated educators who work relentlessly to
                                provide students with an educational experience that reflects rigor, academic
                                excellence, and creativity.
                            </p>
                            <p>
                                We encourage our students to embrace diversity and respect cultural differences.
                                Our primary focus is on facilitating the education of the whole child and fostering
                                a well-rounded student who has integrity and a natural sense of self-worth.
                            </p>
                        </div>
                        <div className="message-card-footer">
                            <Link to="/principal-message" className="message-read-more">
                                Read Full Message <i className="fa-solid fa-arrow-right"></i>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default Message
